import { Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, FormGroup, Input, Label } from "reactstrap";
import { Btn, H4, Image, P } from "../../../AbstractElements";

import logoWhite from "assets/images/logo/logo_tuphap.png";
import axiosInstance from "hook/axiosInstance";
import MoonLoader from "react-spinners/MoonLoader";
import { toast } from "react-toastify";

const LoginForm = () => {
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("Admin@123");
  const [togglePassword, setTogglePassword] = useState(false);
  const [isRememberMe, setRemember] = useState(0);
  const [loading, setLoading] = useState(false);

  const history = useNavigate();

  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const res = await axiosInstance.post("api/User/login", {
        username,
        password,
        isRememberMe: Boolean(isRememberMe),
      });
      setLoading(false);
      const token = res.data.data;
      localStorage.setItem("accessToken", token);

      axiosInstance.defaults.headers = {
        ...axiosInstance.defaults.headers,
        Authorization: `Bearer ${token}`,
      } as any;
      history("/");
      toast.success("Đăng nhập thành công");
    } catch (err) {
      history("/");
      toast.error("Sai tài khoản hoặc mật khẩu");
      setLoading(false);
    }
  };
  return (
    <Fragment>
      {loading && (
        <div className="w-screen h-screen flex items-center justify-center app-overlay">
          <MoonLoader color="#7366ff" />
        </div>
      )}

      <div className="login-card">
        <div>
          <div>
            <div className="logo">
              <Image
                attrImage={{
                  className: "w-20 h-20",
                  src: logoWhite,
                  alt: "looginpage",
                }}
              />
            </div>
          </div>

          <div className="login-main">
            <Form className="theme-form login-form" onSubmit={onSubmit}>
              <H4>Đăng nhập tài khoản</H4>
              <P>Nhập tài khoản và mật khẩu để đăng nhập</P>
              <FormGroup>
                <Label className="col-form-label m-0">Tài khoản</Label>
                <Input
                  className="form-control"
                  required
                  onChange={(e) => setUsername(e.target.value)}
                  value={username}
                />
              </FormGroup>
              <FormGroup className="position-relative">
                <Label className="col-form-label m-0">Mật khẩu</Label>
                <div className="position-relative">
                  <Input
                    className="form-control"
                    type={togglePassword ? "text" : "password"}
                    name="login[password]"
                    required
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                  />
                  <div
                    className="show-hide"
                    onClick={() => setTogglePassword(!togglePassword)}
                  >
                    <span className={togglePassword ? "" : "show"}></span>
                  </div>
                </div>
              </FormGroup>
              <FormGroup className="position-relative">
                <div className="checkbox">
                  <Input
                    id="checkbox1"
                    type="checkbox"
                    value={isRememberMe}
                    onChange={(e) => setRemember(+e.target.checked)}
                  />
                  <Label className="text-muted" for="checkbox1">
                    Nhớ mật khẩu
                  </Label>
                </div>
                <Link className="link" to={"/forgot-pwd"}>
                  Quên mật khẩu?
                </Link>
              </FormGroup>
              <FormGroup>
                <Btn
                  attrBtn={{
                    className: "d-block w-100 mt-2",
                    color: "primary",
                    type: "submit",
                  }}
                >
                  Đăng nhập
                </Btn>
              </FormGroup>
              <FormGroup className="position-relative">
                <Label className="text-muted mt-2">Chưa có tài khoản</Label>
                <Link className="link" to={"/create-acc"}>
                  Tạo mới
                </Link>
              </FormGroup>
            </Form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default LoginForm;
